import React, { useEffect, useState } from 'react';
import { VignetteProps } from '../types';

const NotificationDrop: React.FC<VignetteProps> = ({ reduced }) => {
  const [dropped, setDropped] = useState(reduced);

  useEffect(() => {
    if (reduced) return undefined;
    const t = window.setTimeout(() => setDropped(true), 500);
    return () => window.clearTimeout(t);
  }, [reduced]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 12,
        left: 12,
        right: 12,
        maxWidth: 420,
        margin: '0 auto',
        background: 'rgba(25,0,50,.92)',
        borderRadius: 16,
        padding: '11px 14px',
        display: 'flex',
        gap: 10,
        alignItems: 'center',
        transform: dropped ? 'none' : 'translateY(-90px)',
        opacity: dropped ? 1 : 0,
        transition: reduced ? 'opacity .2s' : 'transform .55s cubic-bezier(.2,.9,.3,1), opacity .3s',
        pointerEvents: 'none',
      }}
      aria-hidden="true"
    >
      <div
        style={{
          width: 30,
          height: 30,
          borderRadius: 8,
          background: '#AB72ED',
          flex: '0 0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: 800,
          fontSize: 15,
          fontFamily: 'Grift, sans-serif',
        }}
      >
        d
      </div>
      <div style={{ fontFamily: 'Grift, sans-serif' }}>
        <div
          style={{
            color: '#F7F5F8', fontSize: 12, fontWeight: 700, lineHeight: '15px',
          }}
        >
          Doqit reminder
        </div>
        <div
          style={{
            color: '#C4AEE0', fontSize: 11, fontWeight: 500, lineHeight: '14px',
          }}
        >
          Car insurance renews tomorrow. Tap to view your doq.
        </div>
      </div>
    </div>
  );
};

export default NotificationDrop;
